import { useState } from "react";

export type Currency = "CAD" | "USD";

const LS_KEY = "preferred_currency";

function detectDefaultCurrency(): Currency {
  try {
    const lang = navigator.language ?? "";
    if (/^(en-CA|fr-CA|fr)/i.test(lang)) return "CAD";
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone ?? "";
    // Canadian timezones — default to CAD
    const canadianTz = [
      "America/Vancouver", "America/Edmonton", "America/Regina",
      "America/Winnipeg", "America/Toronto", "America/Halifax",
      "America/St_Johns", "America/Glace_Bay", "America/Moncton",
      "America/Atikokan", "America/Blanc-Sablon", "America/Creston",
    ];
    if (canadianTz.includes(tz)) return "CAD";
  } catch { /* fail safe */ }
  return "USD";
}

export function useCurrency() {
  const [currency, setCurrencyState] = useState<Currency>(() => {
    try {
      const stored = localStorage.getItem(LS_KEY);
      if (stored === "CAD" || stored === "USD") return stored;
    } catch { /* SSR guard */ }
    return detectDefaultCurrency();
  });

  const setCurrency = (c: Currency) => {
    setCurrencyState(c);
    try { localStorage.setItem(LS_KEY, c); } catch { /* SSR guard */ }
  };

  return { currency, setCurrency, isCAD: currency === "CAD" };
}
